export const CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS';
export const PATIENT_ADDRESS = 'PATIENT_ADDRESS';
export const CUSTOM_ADDRESS = 'CUSTOM_ADDRESS';
export const NOT_SPECIFIED = 'NOT_SPECIFIED';

export const locationMessagesMap = {
  [CUSTOMER_ADDRESS]: {
    id: 'HomeVisitation.Location.CustomersAddress',
    defaultMessage: '** Customer’s address',
  },
  [PATIENT_ADDRESS]: {
    id: 'HomeVisitation.Location.PatientsAddress',
    defaultMessage: '** Patient’s address',
  },
  [CUSTOM_ADDRESS]: {
    id: 'HomeVisitation.Location.CustomAddress',
    defaultMessage: '** Custom address',
  },
  [NOT_SPECIFIED]: {
    id: 'HomeVisitation.Location.NotSpecified',
    defaultMessage: '** Not specified',
  },
};
